export const COLORS = {
  PAPER: '#fffefa',
  PAPER_DARK: '#ffd8bf',
  TEXT: '#333',
  PRIMARY: '#fa541c',
  PRIMARY_LIGHT: '#ffbb96',
  PRIMARY_DARK: '#871400'
};
